import React from 'react';
import { AttendanceManagement } from './list';

const ProjectTeamMembersPage: React.FC = () => {
  return (
    <AttendanceManagement 
      showTabs={true} 
      initialTab="project"
      variant="members"
      defaultViewMode="list"
    />
  );
};

export default ProjectTeamMembersPage;
